var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginViewBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1188,
    height: 933,
    viewBox: "0 0 1188 933",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 743,
    height: 925,
    transform: "translate(446)",
    fill: "#423F6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1951 932.045H0C1.3657 927.619 4.88697 924.147 8.91826 922.567C13.2622 920.872 18.0667 921.136 22.5258 922.403C21.7031 922.172 20.6007 920.691 20.0412 920.066C18.6755 918.569 17.5567 917.006 17.2441 914.949C16.8985 912.645 17.5567 910.309 19.0047 908.499C21.3906 905.455 25.5698 904.369 29.305 904.764C29.4859 904.78 29.6834 904.813 29.8644 904.829C30.5884 904.945 31.3124 905.126 32.0035 905.389C34.9981 906.557 37.6308 908.597 39.9015 910.852C40.3293 911.279 40.7571 911.707 41.1355 912.168C41.1355 912.168 34.8171 906.919 33.3363 902.921C27.857 891.584 39.4572 875.113 53.8876 879.77C59.6794 882.221 64.4183 887.223 67.5446 893.114C55.9938 875.821 75.1465 865.323 81.9421 880.872C77.7298 868.038 84.0152 854.628 96.685 862.164C96.866 862.229 97.0305 862.312 97.2115 862.394V932.045H97.1951Z",
    fill: "#479DA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1942 932.045H39.9336C40.7399 929.428 42.8131 927.388 45.199 926.467C47.7494 925.463 50.5959 925.627 53.2122 926.368C51.8794 923.768 53.7058 920.247 56.2726 919.243C58.8395 918.223 61.7025 919.079 64.1706 920.346C62.048 919.358 60.452 917.252 59.5799 914.899C56.3549 908.219 63.1834 898.511 71.6902 901.259C75.1127 902.707 77.8935 905.652 79.7363 909.124C72.9408 898.939 84.2119 892.752 88.2103 901.917C84.3107 891.896 91.8302 886.006 97.2107 888.276V932.045H97.1942Z",
    fill: "#7BBFBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.812 877.252C39.3422 878.634 41.58 878.453 41.58 878.453C41.58 878.453 41.3167 876.018 39.77 874.636C38.2398 873.254 36.002 873.435 36.002 873.435C36.002 873.435 36.2817 875.87 37.812 877.252Z",
    fill: "#479DA3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9928 893.328C83.1446 895.385 85.6128 896.01 85.6128 896.01C85.6128 896.01 86.2216 893.295 85.0862 891.222C83.9344 889.165 81.4663 888.54 81.4663 888.54C81.4663 888.54 80.841 891.255 81.9928 893.328Z",
    fill: "#7BBFBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4847 871.773C41.8266 874.686 43.3569 877.614 43.3569 877.614C43.3569 877.614 45.9401 875.804 46.5983 872.892C47.2565 869.98 45.7263 867.051 45.7263 867.051C45.7263 867.051 43.1429 868.861 42.4847 871.773Z",
    fill: "#479DA3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M435.387 763.192H464.609V709.058H435.387V763.192Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.893 667.74L387.201 667.625L507.021 803.553H414.926H156.266H64.1719L183.893 667.74Z",
    fill: "#0F3554"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4108 923.787H208.842L208.842 803.54H74.4108L74.4108 923.787Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4158 923.787H89.1094L89.1094 803.54H74.4158L74.4158 923.787Z",
    fill: "#F2786B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.142 923.787H208.836L208.836 803.54H194.142V923.787Z",
    fill: "#F2786B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.143 821.077H89.0996V822.311H194.143V821.077Z",
    fill: "#E1ECEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.143 838.009H89.0996V839.243H194.143V838.009Z",
    fill: "#E1ECEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M194.143 854.956H89.0996V856.19H194.143V854.956Z",
    fill: "#E1ECEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.143 871.887H89.0996V873.122H194.143V871.887Z",
    fill: "#E1ECEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M194.143 888.835H89.0996V890.069H194.143V888.835Z",
    fill: "#E1ECEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.143 905.767H89.0996V907.001H194.143V905.767Z",
    fill: "#E1ECEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.838 821.077H194.145V822.311H208.838V821.077Z",
    fill: "#B72E41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M208.838 838.009H194.145V839.243H208.838V838.009Z",
    fill: "#B72E41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.838 854.956H194.145V856.19H208.838V854.956Z",
    fill: "#B72E41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.838 871.888H194.145V873.122H208.838V871.888Z",
    fill: "#B72E41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.838 888.836H194.145V890.07H208.838V888.836Z",
    fill: "#B72E41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M208.838 905.767H194.145V907.001H208.838V905.767Z",
    fill: "#B72E41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0979 821.077H74.4043V822.311H89.0979V821.077Z",
    fill: "#B72E41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0979 838.009H74.4043V839.243H89.0979V838.009Z",
    fill: "#B72E41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0979 854.956H74.4043V856.19H89.0979V854.956Z",
    fill: "#B72E41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0979 871.888H74.4043V873.122H89.0979V871.888Z",
    fill: "#B72E41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0979 888.836H74.4043V890.07H89.0979V888.836Z",
    fill: "#B72E41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0979 905.767H74.4043V907.001H89.0979V905.767Z",
    fill: "#B72E41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6694 899.822H184.129V848.962H99.6694V899.822Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M362.35 923.787H496.781V803.54H362.35V923.787Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M496.785 821.077H363.506V822.311H496.785V821.077Z",
    fill: "#E1ECEF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M496.785 838.009H363.506V839.243H496.785V838.009Z",
    fill: "#E1ECEF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M496.785 854.956H363.506V856.19H496.785V854.956Z",
    fill: "#E1ECEF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M496.785 871.887H363.506V873.122H496.785V871.887Z",
    fill: "#E1ECEF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M496.785 888.835H363.506V890.069H496.785V888.835Z",
    fill: "#E1ECEF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M496.785 905.767H363.506V907.001H496.785V905.767Z",
    fill: "#E1ECEF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M385.319 923.793H473.826V828.26H385.319V923.793Z",
    fill: "#F2786B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M385.309 832.463L473.816 846.828V828.268H385.309V832.463Z",
    fill: "#B72E41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M362.354 923.801H368.228L364.558 803.554H362.354V923.801Z",
    fill: "#9BB8CC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M399.905 923.796H458.992V848.946H399.905V923.796Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M431.662 919.64H454.715V852.391H431.662V919.64Z",
    fill: "#445C77"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M404.414 919.64H427.467V852.391H404.414V919.64Z",
    fill: "#445C77"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M165.967 895.846H180.184V852.39H165.967V895.846Z",
    fill: "#445C77"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M121.388 895.846H161.865V852.39H121.388V895.846Z",
    fill: "#445C77"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M103.051 895.846H117.268V852.39H103.051V895.846Z",
    fill: "#445C77"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6641 848.292H184.124H185.374L186.411 899.827H184.124V848.95H99.6641V848.292Z",
    fill: "#9BB8CC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M399.902 847.914H458.989H459.565H460.306L461.03 923.801H458.989V848.951H399.902V847.914Z",
    fill: "#B72E41"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M184.124 899.399H99.6641V900.601L186.411 904.27V899.399H184.124Z",
    fill: "#9BB8CC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M362.354 805.528L496.784 812.883V803.554H362.354V805.528Z",
    fill: "#9BB8CC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194.143 803.554V812.077L89.0996 806.334V803.554H194.143Z",
    fill: "#9BB8CC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0999 803.554V806.334L74.4062 805.528V803.554H89.0999Z",
    fill: "#B72E41"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M208.838 803.554V812.883L194.145 812.077V803.554H208.838Z",
    fill: "#B72E41"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M431.964 722.77H468.031V716.237H431.964V722.77Z",
    fill: "#0F3554"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M464.617 722.779V727.995L435.395 724.655V722.779H464.617Z",
    fill: "#9BB8CC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M208.836 923.801H362.354V736.848L285.595 676.955L208.836 736.848V923.801Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M285.595 676.955L362.354 736.848V750.39L289.165 693.821L208.836 756.511V736.848L285.595 676.955Z",
    fill: "#9BB8CC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M196.645 738.444L285.596 671.689L374.482 739.102L365.827 747.774L285.596 685.165L205.711 747.51L196.645 738.444Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M314.961 919.64H338.014V852.391H314.961V919.64Z",
    fill: "#445C77"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M287.694 919.64H310.746V852.391H287.694V919.64Z",
    fill: "#445C77"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M260.444 919.64H283.496V852.391H260.444V919.64Z",
    fill: "#445C77"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M233.178 919.64H256.23V852.391H233.178V919.64Z",
    fill: "#445C77"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M230.49 848.292H343.58L345.341 923.8H341.787V848.95H230.49V848.292Z",
    fill: "#9BB8CC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M287.694 805.288H310.746V738.04H287.694V805.288Z",
    fill: "#445C77"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M260.446 805.288H283.498V738.04H260.446V805.288Z",
    fill: "#445C77"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M256.719 733.969H316.118L317.863 809.461H314.325V734.61H256.719V733.969Z",
    fill: "#9BB8CC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M225.207 815.183H345.965V808.979H225.207V815.183Z",
    fill: "#0F3554"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M225.225 815.17H345.966V808.967L350.606 815.17V821.011L225.225 816.552V815.17Z",
    fill: "#9BB8CC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M338.737 808.971H340.695V792.056H338.737V808.971Z",
    fill: "#7BBFBA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M273.319 808.971H275.277V792.056H273.319V808.971Z",
    fill: "#7BBFBA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M295.124 808.971H297.082V792.056H295.124V808.971Z",
    fill: "#7BBFBA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M251.513 808.971H253.471V792.056H251.513V808.971Z",
    fill: "#7BBFBA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M316.931 808.971H318.889V792.056H316.931V808.971Z",
    fill: "#7BBFBA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M229.708 808.971H231.666V792.056H229.708V808.971Z",
    fill: "#7BBFBA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M338.737 793.653H340.695V792.057H338.737V793.653Z",
    fill: "#4A938C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M273.319 793.653H275.277V792.057H273.319V793.653Z",
    fill: "#4A938C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M295.124 793.653H297.082V792.057H295.124V793.653Z",
    fill: "#4A938C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M251.513 793.653H253.471V792.057H251.513V793.653Z",
    fill: "#4A938C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M316.931 793.653H318.889V792.057H316.931V793.653Z",
    fill: "#4A938C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M229.708 793.653H231.666V792.057H229.708V793.653Z",
    fill: "#4A938C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M227.941 792.068H343.384V787.773L227.941 788.777V792.068Z",
    fill: "#7BBFBA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2018 932.032H505.613V923.789H70.2018V932.032Z",
    fill: "#7BBFBA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89523 917.619H102.182V915.003H6.89523V917.619Z",
    fill: "#B6CCD8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89523 928.281H102.182V925.665H6.89523V928.281Z",
    fill: "#B6CCD8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0558 932.042H99.6137C99.8934 932.042 100.124 931.828 100.124 931.564V911.885C100.124 911.786 100.091 911.671 100.025 911.589L97.7379 908.808C97.5404 908.561 97.1456 908.561 96.9316 908.808L94.6445 911.589C94.5787 911.671 94.5293 911.77 94.5293 911.885V931.564C94.5458 931.828 94.7761 932.042 95.0558 932.042Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 932.042H90.0862C90.366 932.042 90.5963 931.828 90.5963 931.564V911.885C90.5963 911.786 90.5634 911.671 90.4811 911.589L88.1941 908.808C87.9966 908.561 87.6017 908.561 87.3878 908.808L85.1007 911.589C85.0349 911.671 85.002 911.77 85.002 911.885V931.564C85.0184 931.828 85.2488 932.042 85.5285 932.042Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0012 932.042H80.559C80.8387 932.042 81.0691 931.828 81.0691 931.564V911.885C81.0691 911.786 81.0362 911.671 80.9704 911.589L78.6832 908.808C78.4858 908.561 78.0909 908.561 77.877 908.808L75.5898 911.589C75.524 911.671 75.4746 911.77 75.4746 911.885V931.564C75.4911 931.828 75.7214 932.042 76.0012 932.042Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4758 932.042H71.0336C71.3133 932.042 71.5437 931.828 71.5437 931.564V911.885C71.5437 911.786 71.5108 911.671 71.4285 911.589L69.1413 908.808C68.9439 908.561 68.549 908.561 68.3351 908.808L66.0479 911.589C65.9821 911.671 65.9492 911.77 65.9492 911.885V931.564C65.9657 931.828 66.196 932.042 66.4758 932.042Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9473 932.042H61.5051C61.7848 932.042 62.0151 931.828 62.0151 931.564V911.885C62.0151 911.786 61.9822 911.671 61.8999 911.589L59.6129 908.808C59.4154 908.561 59.0205 908.561 58.8065 908.808L56.5195 911.589C56.4537 911.671 56.4043 911.77 56.4043 911.885V931.564C56.4372 931.828 56.6676 932.042 56.9473 932.042Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4055 932.042H51.9633C52.243 932.042 52.4734 931.828 52.4734 931.564V911.885C52.4734 911.786 52.4405 911.671 52.3747 911.589L50.0875 908.808C49.89 908.561 49.4952 908.561 49.2813 908.808L46.9941 911.589C46.9283 911.671 46.8789 911.77 46.8789 911.885V931.564C46.9118 931.828 47.1257 932.042 47.4055 932.042Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8781 932.042H42.436C42.7157 932.042 42.946 931.828 42.946 931.564V911.885C42.946 911.786 42.9131 911.671 42.8308 911.589L40.5437 908.808C40.3462 908.561 39.9513 908.561 39.7374 908.808L37.4503 911.589C37.3845 911.671 37.3516 911.77 37.3516 911.885V931.564C37.368 931.828 37.5984 932.042 37.8781 932.042Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3508 932.042H32.9085C33.1882 932.042 33.4186 931.828 33.4186 931.564V911.885C33.4186 911.786 33.3857 911.671 33.3199 911.589L31.0328 908.808C30.8354 908.561 30.4404 908.561 30.2265 908.808L27.9394 911.589C27.8736 911.671 27.8242 911.77 27.8242 911.885V931.564C27.8407 931.828 28.071 932.042 28.3508 932.042Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8234 932.042H23.3813C23.661 932.042 23.8913 931.828 23.8913 931.564V911.885C23.8913 911.786 23.8584 911.671 23.7762 911.589L21.489 908.808C21.2915 908.561 20.8967 908.561 20.6828 908.808L18.3956 911.589C18.3298 911.671 18.2969 911.77 18.2969 911.885V931.564C18.3133 931.828 18.5437 932.042 18.8234 932.042Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29692 932.042H13.8548C14.1345 932.042 14.3649 931.828 14.3649 931.564V911.885C14.3649 911.786 14.3319 911.671 14.2497 911.589L11.9625 908.808C11.765 908.561 11.3702 908.561 11.1563 908.808L8.8691 911.589C8.80328 911.671 8.75391 911.77 8.75391 911.885V931.564C8.78681 931.828 9.0172 932.042 9.29692 932.042Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M892.951 709.633V656.519H928.739V683.684L892.951 709.633Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M892.951 709.633V656.519H928.739V683.684L892.951 709.633Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M928.739 681.973V683.684L892.951 709.632V681.973H928.739Z",
    fill: "#F2786B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M921.258 667.444H924.055V660.961H921.258V667.444Z",
    fill: "#0F3554"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M913.38 667.444H916.178V660.961H913.38V667.444Z",
    fill: "#0F3554"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M905.519 667.444H908.316V660.961H905.519V667.444Z",
    fill: "#0F3554"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M897.642 667.444H900.439V660.961H897.642V667.444Z",
    fill: "#0F3554"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.1 932.176H1217.63C1216.99 929.806 1215.34 927.947 1213.45 927.091C1211.42 926.186 1209.17 926.318 1207.08 927.009C1207.46 926.877 1207.99 926.088 1208.25 925.758C1208.89 924.952 1209.42 924.113 1209.55 923.011C1209.71 921.777 1209.4 920.526 1208.73 919.555C1207.61 917.926 1205.65 917.334 1203.9 917.548C1203.82 917.564 1203.72 917.564 1203.64 917.581C1203.3 917.647 1202.97 917.745 1202.64 917.877C1201.24 918.502 1200 919.605 1198.94 920.806C1198.74 921.036 1198.54 921.266 1198.36 921.513C1198.36 921.513 1201.32 918.7 1202.01 916.561C1204.58 910.472 1199.15 901.653 1192.39 904.154C1189.67 905.47 1187.45 908.152 1185.99 911.312C1191.4 902.048 1182.43 896.421 1179.24 904.746C1181.21 897.869 1178.27 890.678 1172.33 894.709C1172.25 894.742 1172.16 894.792 1172.08 894.824V932.176H1172.1Z",
    fill: "#479DA3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.1 932.175H1198.92C1198.54 930.777 1197.57 929.691 1196.45 929.181C1195.25 928.638 1193.93 928.72 1192.7 929.131C1193.32 927.733 1192.47 925.857 1191.27 925.314C1190.07 924.771 1188.72 925.215 1187.56 925.906C1188.57 925.38 1189.31 924.245 1189.72 922.994C1191.23 919.407 1188.03 914.207 1184.04 915.688C1182.45 916.462 1181.13 918.041 1180.28 919.901C1183.47 914.438 1178.19 911.131 1176.31 916.034C1178.14 910.653 1174.62 907.511 1172.1 908.712V932.175Z",
    fill: "#7BBFBA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.22 911.426C1178.68 912.529 1177.53 912.874 1177.53 912.874C1177.53 912.874 1177.25 911.41 1177.77 910.307C1178.32 909.205 1179.47 908.859 1179.47 908.859C1179.47 908.859 1179.75 910.324 1179.22 911.426Z",
    fill: "#7BBFBA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M737.047 932.357H804.081V783.43L737.047 825.52V932.357Z",
    fill: "#F2786B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M737.047 849.362L804.081 798.864V783.43L737.047 825.618V849.362Z",
    fill: "#B72E41"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M804.082 932.127H1174.3V772.751L992.285 639.488L804.082 772.751V932.127Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M991.43 637.185L1174.47 773.837V792.233L994.375 658.756L804.082 798.864V778.724L991.43 637.185Z",
    fill: "#9BB8CC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M991.43 635.358L1189.09 777.144L1178.91 789.238L991.43 649.262L736.916 839.374L727.422 826.737L991.43 635.358Z",
    fill: "#0F3554"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M804.083 808.935H778.299V810.169H804.083V808.935Z",
    fill: "#B72E41"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M804.081 829.453H749.996V830.687H804.081V829.453Z",
    fill: "#B72E41"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M804.081 849.987H737.047V851.221H804.081V849.987Z",
    fill: "#B72E41"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M804.081 870.522H737.047V871.757H804.081V870.522Z",
    fill: "#B72E41"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M804.081 891.058H737.047V892.292H804.081V891.058Z",
    fill: "#B72E41"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M804.081 911.592H737.047V912.826H804.081V911.592Z",
    fill: "#B72E41"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M737.04 894.772H777.336V853.999H737.04V894.772Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M737.035 891.334H773.859V857.438H737.035V891.334Z",
    fill: "#445C77"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M777.343 854.002H780.535V898.132H737.047V894.775H777.343V854.002Z",
    fill: "#B72E41"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M732.04 932.361H804.076V926.29H732.04V932.361Z",
    fill: "#0F3554"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M991.202 789.132H1046.49V718.033H991.202V789.132Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.9 785.365H1042.88V721.243H1020.9V785.365Z",
    fill: "#445C77"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M994.918 785.365H1016.9V721.243H994.918V785.365Z",
    fill: "#445C77"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M936.222 789.132H991.508V718.033H936.222V789.132Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M965.92 785.365H987.902V721.243H965.92V785.365Z",
    fill: "#445C77"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M939.937 785.365H961.92V721.243H939.937V785.365Z",
    fill: "#445C77"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M937.568 735.832H1044.39V734.071H937.568V735.832Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.59 789.123H1046.49V718.024H1047.69L1048.59 789.123Z",
    fill: "#9BB8CC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.23 819.991H1104.36V820.567H1137.23V819.991Z",
    fill: "#F2786B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.65 932.137H1104.37V844.732H1007.65V932.137Z",
    fill: "#7BBFBA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M876.087 819.991H843.211V820.567H876.087V819.991Z",
    fill: "#F2786B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.3 820.583V833.286L1137.25 833.121V820.583H1143.3Z",
    fill: "#9BB8CC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M837.139 820.583H843.21V824.598L837.139 824.417V820.583Z",
    fill: "#9BB8CC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 820.583V832.167L1007.64 829.353V820.583H1104.35Z",
    fill: "#9BB8CC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M974.762 820.583V828.399L876.086 825.552V820.583H974.762Z",
    fill: "#9BB8CC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.25 820.583V833.121L1139.6 932.126H1104.36V832.167V820.583H1137.25Z",
    fill: "#F2786B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M876.086 820.583V825.552V932.126H840.266L843.211 824.598V820.583H876.086Z",
    fill: "#F2786B"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.64 820.583V829.32V932.126H974.762V828.366V820.583H1007.64Z",
    fill: "#F2786B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.25 820.583V821.011V824.466H1104.36V820.978V820.583H1137.25Z",
    fill: "#B72E41"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M876.087 820.583V820.748V824.466H843.211V820.715V820.583H876.087Z",
    fill: "#B72E41"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.64 820.583V820.879V824.499H974.762V820.846V820.583H1007.64Z",
    fill: "#B72E41"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M876.086 932.136H974.762V923.086H876.086V932.136Z",
    fill: "#7BBFBA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M876.086 932.136H974.762V923.086H876.086V932.136Z",
    fill: "#7BBFBA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M884.808 923.075H966.059V914.025H884.808V923.075Z",
    fill: "#7BBFBA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M884.808 923.075H966.059V921.561H884.808V923.075Z",
    fill: "#479DA3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M904.288 914.018H946.559V839.365H904.288V914.018Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M903.531 840.493L947.316 842.402V839.374H903.531V840.493Z",
    fill: "#9BB8CC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M948.582 837.581H946.559V914.011H948.582V837.581Z",
    fill: "#9BB8CC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M904.305 837.581H902.281V914.011H904.305V837.581Z",
    fill: "#9BB8CC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M940.012 891.551H910.855V908.663H940.012V891.551Z",
    fill: "#445C77"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M910.855 888.079V849.625H915.709C917.914 846.647 921.452 844.722 925.434 844.722C929.416 844.722 932.953 846.647 935.158 849.625H940.012V888.079H910.855Z",
    fill: "#445C77"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M896.192 839.367H954.654V835.204H896.192V839.367Z",
    fill: "#0F3554"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 848.753H1007.64V849.987H1104.35V848.753Z",
    fill: "#479DA3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 853.919H1007.64V855.153H1104.35V853.919Z",
    fill: "#479DA3"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 859.103H1007.64V860.337H1104.35V859.103Z",
    fill: "#479DA3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 864.285H1007.64V865.519H1104.35V864.285Z",
    fill: "#479DA3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 869.469H1007.64V870.703H1104.35V869.469Z",
    fill: "#479DA3"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 874.651H1007.64V875.885H1104.35V874.651Z",
    fill: "#479DA3"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 879.835H1007.64V881.069H1104.35V879.835Z",
    fill: "#479DA3"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 885.019H1007.64V886.253H1104.35V885.019Z",
    fill: "#479DA3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 890.185H1007.64V891.419H1104.35V890.185Z",
    fill: "#479DA3"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 895.368H1007.64V896.602H1104.35V895.368Z",
    fill: "#479DA3"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 900.551H1007.64V901.785H1104.35V900.551Z",
    fill: "#479DA3"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 905.734H1007.64V906.968H1104.35V905.734Z",
    fill: "#479DA3"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 910.917H1007.64V912.151H1104.35V910.917Z",
    fill: "#479DA3"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 916.1H1007.64V917.334H1104.35V916.1Z",
    fill: "#479DA3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 921.283H1007.64V922.517H1104.35V921.283Z",
    fill: "#479DA3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.35 926.466H1007.64V927.7H1104.35V926.466Z",
    fill: "#479DA3"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.65 844.724H1104.37V840.89H1007.65V844.724Z",
    fill: "#0F3554"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.05 788.502H1133.04V772.13H1121.05V788.502Z",
    fill: "#7BBFBA"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.28 788.502H1065.27V772.13H1053.28V788.502Z",
    fill: "#7BBFBA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M917.751 788.502H929.746V772.13H917.751V788.502Z",
    fill: "#7BBFBA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M985.505 788.502H997.5V772.13H985.505V788.502Z",
    fill: "#7BBFBA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M849.978 788.502H861.973V772.13H849.978V788.502Z",
    fill: "#7BBFBA"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.05 774.048H1133.04V772.123H1121.05V774.048Z",
    fill: "#479DA3"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.28 774.048H1065.27V772.123H1053.28V774.048Z",
    fill: "#479DA3"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M917.751 774.048H929.746V772.123H917.751V774.048Z",
    fill: "#479DA3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M985.505 774.048H997.5V772.123H985.505V774.048Z",
    fill: "#479DA3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M849.978 774.048H861.973V772.123H849.978V774.048Z",
    fill: "#479DA3"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M848.116 772.136H1135.29V770.211H848.116V772.136Z",
    fill: "#7BBFBA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M837.139 820.584H1143.3L1144.65 787.725L837.139 788.498V820.584Z",
    fill: "#0F3554"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M992.549 698.066V684.228C996.251 684.491 999.558 686.12 1002.01 688.604L992.549 698.066Z",
    fill: "#445C77"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.24 690.02C1005.1 692.488 1006.22 695.548 1006.22 698.872V698.888H994.375L1003.24 690.02Z",
    fill: "#445C77"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M981.623 688.012C984.042 685.807 987.201 684.408 990.673 684.211V697.062C987.662 694.051 984.634 691.023 981.623 688.012Z",
    fill: "#445C77"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M989.851 698.905H976.803V698.888C976.803 695.252 978.136 691.945 980.324 689.378C983.5 692.537 986.675 695.729 989.851 698.905Z",
    fill: "#445C77"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M974.68 701.208H1009.2C1009.2 701.191 1009.2 701.191 1009.2 701.175C1009.2 696.025 1007.32 691.352 1004.28 687.88C1011.11 693.211 1010.73 702.458 1010.73 702.475H974.696V701.208H974.68Z",
    fill: "#9BB8CC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.04 871.715H1162.71V847.725H1149.04V871.715Z",
    fill: "#445C77"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.63 845.61V873.55H1146.59V874.553H1165.43V845.61H1164.63Z",
    fill: "#9BB8CC"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M816.676 871.715H830.35V847.725H816.676V871.715Z",
    fill: "#445C77"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M832.269 845.61V873.549H814.219V874.553H833.059V845.61H832.269Z",
    fill: "#9BB8CC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.33 932.127H1196.23L1194.36 906.359H1188.2L1186.33 932.127Z",
    fill: "#0F3554"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 820.583H1196.4L1200.17 802.022H1182.41L1186.16 820.583Z",
    fill: "#0F3554"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.07 817.144H1194.51L1196.88 805.462H1185.7L1188.07 817.144Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 797.317H1196.4L1200.17 802.023H1182.41L1186.16 797.317Z",
    fill: "#0F3554"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 820.583H1197.14C1197.67 820.583 1198.09 820.156 1198.09 819.629C1198.09 819.103 1197.67 818.675 1197.14 818.675H1185.39C1184.87 818.675 1184.44 819.103 1184.44 819.629C1184.44 820.139 1184.87 820.583 1185.39 820.583Z",
    fill: "#0F3554"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.07 907.314H1194.49C1195.02 907.314 1195.44 906.886 1195.44 906.36C1195.44 905.833 1195.02 905.405 1194.49 905.405H1188.07C1187.55 905.405 1187.12 905.833 1187.12 906.36C1187.1 906.886 1187.55 907.314 1188.07 907.314Z",
    fill: "#0F3554"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.68 926.417C1137.23 915.13 1151.79 913.353 1156.61 924.246C1162.62 922.6 1167.46 924.739 1171.4 929.132C1173.35 926.681 1177.94 925.726 1181.36 927.717C1184.11 918.964 1195.4 917.598 1199.11 926.039C1204.76 924.492 1209.07 927.257 1212.44 932.193H1173.79H1167.04H1115.2C1120.87 927.405 1126.86 924.476 1133.68 926.417Z",
    fill: "#479DA3"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.91 932.127C1160.81 927.882 1164.51 925.496 1169.35 926.829C1172.54 919.572 1182.23 920.757 1184.6 928.277C1189.14 926.977 1193.12 928.935 1196.89 932.127H1157.91Z",
    fill: "#7BBFBA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.73 921.531C1157.19 922.419 1158.24 922.781 1158.24 922.781C1158.24 922.781 1158.55 921.712 1158.09 920.823C1157.63 919.935 1156.58 919.573 1156.58 919.573C1156.58 919.573 1156.27 920.642 1156.73 921.531Z",
    fill: "#479DA3"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 920.165C1159.03 921.267 1159.21 922.798 1159.21 922.798C1159.21 922.798 1160.74 922.551 1161.57 921.465C1162.39 920.379 1162.22 918.832 1162.22 918.832C1162.22 918.832 1160.71 919.063 1159.87 920.165Z",
    fill: "#479DA3"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M613.955 517.859H589.142C587.76 517.859 586.641 516.724 586.641 515.358C586.641 513.976 587.776 512.857 589.142 512.857H613.955C615.337 512.857 616.456 513.993 616.456 515.358C616.472 516.724 615.337 517.859 613.955 517.859Z",
    fill: "#416793"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M627.135 515.358C627.135 516.741 626.016 517.859 624.634 517.859C623.252 517.859 622.133 516.741 622.133 515.358C622.133 513.976 623.252 512.857 624.634 512.857C626.016 512.857 627.135 513.976 627.135 515.358Z",
    fill: "#416793"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M981.74 342.72C981.624 341.963 981.559 341.206 981.559 340.416C981.559 332.518 987.959 326.101 995.874 326.101C998.292 326.101 1000.56 326.693 1002.55 327.763C1004.3 328.684 1007.23 329.046 1008.43 326.265C1011.51 318.746 1018.89 313.448 1027.53 313.448C1031.94 313.448 1036.04 314.83 1039.4 317.199C1041.37 318.581 1044.78 318.466 1045.89 315.323C1049.86 303.476 1061.05 294.937 1074.25 294.937C1088.54 294.937 1100.49 304.974 1103.44 318.4C1103.99 321.066 1105.97 322.81 1109.82 322.185C1110.87 321.971 1111.97 321.856 1113.09 321.856C1120.43 321.856 1126.64 326.66 1128.76 333.308C1129.32 335.068 1131.05 335.611 1132.79 334.575C1134.53 333.406 1136.64 332.715 1138.91 332.715C1144.64 332.715 1149.34 337.109 1149.85 342.703H981.74V342.72Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.45 329.803C1047.31 324.126 1043.59 320.194 1038.39 317.035L1038.82 316.327C1044.15 319.569 1047.95 323.6 1051.18 329.392L1050.45 329.803Z",
    fill: "#D1DFE8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.73 332.057L1095.04 331.613C1100.67 322.925 1108.96 321.905 1109.31 321.855L1109.41 322.678C1109.31 322.678 1101.15 323.698 1095.73 332.057Z",
    fill: "#D1DFE8"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.33 336.105L1084.74 335.529C1087.67 332.567 1091.54 331.02 1095.36 331.284C1098.61 331.514 1101.44 333.028 1103.34 335.562L1102.68 336.055C1100.93 333.719 1098.3 332.304 1095.29 332.106C1091.74 331.876 1088.08 333.324 1085.33 336.105Z",
    fill: "#D1DFE8"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M996.581 333.242L995.988 332.667C998.917 329.705 1002.77 328.175 1006.6 328.421C1009.86 328.652 1012.69 330.165 1014.58 332.699L1013.92 333.193C1012.18 330.857 1009.55 329.458 1006.54 329.244C1002.98 329.014 999.345 330.462 996.581 333.242Z",
    fill: "#D1DFE8"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M882.635 385.254C884.84 385.254 889.036 385.6 891.422 381.898C895.799 375.826 902.923 371.877 910.969 371.877C918.061 371.877 924.412 374.937 928.822 379.808C930.435 381.601 934.466 383.411 938.448 381.634C940.39 380.779 942.545 380.285 944.799 380.285C950.805 380.285 956.005 383.658 958.654 388.594C959.411 390.026 961.648 391.457 964.561 390.52C966.009 389.96 967.588 389.648 969.25 389.648C974.038 389.648 978.218 392.198 980.521 396.015H960.513H957.979H871.891C871.891 395.999 871.891 395.999 871.891 395.982C871.891 390.075 876.712 385.254 882.635 385.254Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M927.373 388.956L926.748 388.413C930.286 384.283 936.472 381.881 936.736 381.782L937.032 382.556C936.966 382.572 930.763 384.991 927.373 388.956Z",
    fill: "#D1DFE8"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M893.1 390.52C893.084 390.487 891.224 386.488 884.215 385.682L884.314 384.859C891.833 385.731 893.775 390.01 893.857 390.191L893.1 390.52Z",
    fill: "#D1DFE8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M491.972 97.709H422.105V118.065H491.972V97.709Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M615.208 97.709H545.342V118.065H615.208V97.709Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M767.657 97.709H697.791V118.065H767.657V97.709Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M834.986 126.615H389.201V894.616H834.986V126.615Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M851.919 894.615H372.236V930.527H851.919V894.615Z",
    fill: "#7BBFBA"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M739.578 918.556H484.607V930.527H739.578V918.556Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M720.657 906.586H503.529V918.557H720.657V906.586Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M697.32 894.615H526.834V906.586H697.32V894.615Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M697.32 904.186H526.834V906.586H697.32V904.186Z",
    fill: "#8AADC1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M720.657 916.157H503.529V918.557H720.657V916.157Z",
    fill: "#8AADC1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 645.162H648.664V767.958H834.982V645.162Z",
    fill: "#F2786B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M652.746 645.162H648.664V767.958H652.746V645.162Z",
    fill: "#B72E41"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M634.599 805.993H589.336V894.615H634.599V805.993Z",
    fill: "#445C77"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M769.364 674.232H691.527V767.957H769.364V674.232Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M765.203 679.309H732.711V763.131H765.203V679.309Z",
    fill: "#445C77"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M727.992 679.309H695.5V763.131H727.992V679.309Z",
    fill: "#445C77"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M834.986 785.996L389.201 794.105V783.845H834.986V785.996Z",
    fill: "#8AADC1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M648.667 655.257L389.201 663.366V653.105H648.667V655.257Z",
    fill: "#8AADC1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 656.939L648.664 668.027V653.105H834.982V656.939Z",
    fill: "#B72E41"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 748.815H667.861V767.93H674.922V748.815Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 748.815H749.643V767.93H756.704V748.815Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 748.815H831.449V767.93H838.51V748.815Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 748.815H790.545V767.93H797.606V748.815Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 748.815H708.766V767.93H715.827V748.815Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 748.815H667.861V752.649H674.922V748.815Z",
    fill: "#8AADC1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 748.815H749.643V752.649H756.704V748.815Z",
    fill: "#8AADC1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 748.815H831.449V752.649H838.51V748.815Z",
    fill: "#8AADC1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 748.815H790.545V752.649H797.606V748.815Z",
    fill: "#8AADC1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 748.815H708.766V752.649H715.827V748.815Z",
    fill: "#8AADC1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M846.541 767.931H377.643V783.846H846.541V767.931Z",
    fill: "#0F3554"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M846.539 745.368H648.664V748.816H846.539V745.368Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M554.913 783.845H532.902V894.587H554.913V783.845Z",
    fill: "#F2786B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M691.253 783.845H669.242V894.587H691.253V783.845Z",
    fill: "#F2786B"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M554.913 783.845H532.902V788.975H554.913V783.845Z",
    fill: "#B72E41"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M691.253 783.845H669.242V788.975H691.253V783.845Z",
    fill: "#B72E41"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 829.687H418.518V878.618H432.392V829.687Z",
    fill: "#445C77"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 808.834H418.518V825.466H432.392V808.834Z",
    fill: "#445C77"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 829.687H435.205V878.618H481.24V829.687Z",
    fill: "#445C77"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 808.834H435.205V825.466H481.24V808.834Z",
    fill: "#445C77"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 829.687H484.082V878.618H497.956V829.687Z",
    fill: "#445C77"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 808.834H484.082V825.466H497.956V808.834Z",
    fill: "#445C77"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M415.098 805.993H412.863V885.265H501.209V882.865H415.098V805.993Z",
    fill: "#8AADC1"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 699.72H418.518V748.651H432.392V699.72Z",
    fill: "#445C77"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 678.867H418.518V695.499H432.392V678.867Z",
    fill: "#445C77"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 699.72H435.205V748.651H481.24V699.72Z",
    fill: "#445C77"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 678.867H435.205V695.499H481.24V678.867Z",
    fill: "#445C77"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 699.72H484.082V748.651H497.956V699.72Z",
    fill: "#445C77"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 678.867H484.082V695.499H497.956V678.867Z",
    fill: "#445C77"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M415.098 676.026H412.863V755.298H501.209V752.898H415.098V676.026Z",
    fill: "#8AADC1"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 514.394H648.664V637.19H834.982V514.394Z",
    fill: "#F2786B"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M652.746 514.394H648.664V637.19H652.746V514.394Z",
    fill: "#B72E41"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M846.541 506.45H377.643V522.365H846.541V506.45Z",
    fill: "#0F3554"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M769.364 543.466H691.527V637.19H769.364V543.466Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M765.203 548.568H732.711V632.391H765.203V548.568Z",
    fill: "#445C77"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M727.992 548.568H695.5V632.391H727.992V548.568Z",
    fill: "#445C77"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M648.667 524.489L389.201 532.626V522.365H648.667V524.489Z",
    fill: "#8AADC1"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 526.199L648.664 537.287V522.365H834.982V526.199Z",
    fill: "#B72E41"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 618.076H667.861V637.191H674.922V618.076Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 618.076H749.643V637.191H756.704V618.076Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 618.076H831.449V637.191H838.51V618.076Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 618.076H790.545V637.191H797.606V618.076Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 618.076H708.766V637.191H715.827V618.076Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 618.076H667.861V621.91H674.922V618.076Z",
    fill: "#8AADC1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 618.076H749.643V621.91H756.704V618.076Z",
    fill: "#8AADC1"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 618.076H831.449V621.91H838.51V618.076Z",
    fill: "#8AADC1"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 618.076H790.545V621.91H797.606V618.076Z",
    fill: "#8AADC1"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 618.076H708.766V621.91H715.827V618.076Z",
    fill: "#8AADC1"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M846.539 614.601H648.664V618.048H846.539V614.601Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 568.98H418.518V617.911H432.392V568.98Z",
    fill: "#445C77"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 548.128H418.518V564.76H432.392V548.128Z",
    fill: "#445C77"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 568.98H435.205V617.911H481.24V568.98Z",
    fill: "#445C77"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 548.128H435.205V564.76H481.24V548.128Z",
    fill: "#445C77"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 568.98H484.082V617.911H497.956V568.98Z",
    fill: "#445C77"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 548.128H484.082V564.76H497.956V548.128Z",
    fill: "#445C77"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M415.098 545.259H412.863V624.53H501.209V622.158H415.098V545.259Z",
    fill: "#8AADC1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 383.654H648.664V506.45H834.982V383.654Z",
    fill: "#F2786B"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M652.746 383.654H648.664V506.45H652.746V383.654Z",
    fill: "#B72E41"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M846.539 375.684H377.641V391.599H846.539V375.684Z",
    fill: "#0F3554"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M769.364 412.726H691.527V506.45H769.364V412.726Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M765.203 417.828H732.711V501.651H765.203V417.828Z",
    fill: "#445C77"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M727.992 417.828H695.5V501.651H727.992V417.828Z",
    fill: "#445C77"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M648.667 393.749L389.201 401.858V391.598H648.667V393.749Z",
    fill: "#8AADC1"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 395.432L648.664 406.547V391.598H834.982V395.432Z",
    fill: "#B72E41"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 487.309H667.861V506.423H674.922V487.309Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 487.309H749.643V506.423H756.704V487.309Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 487.309H831.449V506.423H838.51V487.309Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 487.309H790.545V506.423H797.606V487.309Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 487.309H708.766V506.423H715.827V487.309Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 487.309H667.861V491.143H674.922V487.309Z",
    fill: "#8AADC1"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 487.309H749.643V491.143H756.704V487.309Z",
    fill: "#8AADC1"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 487.309H831.449V491.143H838.51V487.309Z",
    fill: "#8AADC1"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 487.309H790.545V491.143H797.606V487.309Z",
    fill: "#8AADC1"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 487.309H708.766V491.143H715.827V487.309Z",
    fill: "#8AADC1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M846.539 483.86H648.664V487.308H846.539V483.86Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 438.212H418.518V487.143H432.392V438.212Z",
    fill: "#445C77"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 417.388H418.518V434.02H432.392V417.388Z",
    fill: "#445C77"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 438.212H435.205V487.143H481.24V438.212Z",
    fill: "#445C77"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 417.388H435.205V434.02H481.24V417.388Z",
    fill: "#445C77"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 438.212H484.082V487.143H497.956V438.212Z",
    fill: "#445C77"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 417.388H484.082V434.02H497.956V417.388Z",
    fill: "#445C77"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M415.098 414.519H412.863V493.79H501.209V491.39H415.098V414.519Z",
    fill: "#8AADC1"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M554.444 699.72H540.57V748.651H554.444V699.72Z",
    fill: "#445C77"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M554.444 678.867H540.57V695.499H554.444V678.867Z",
    fill: "#445C77"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M603.291 699.72H557.256V748.651H603.291V699.72Z",
    fill: "#445C77"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M603.291 678.867H557.256V695.499H603.291V678.867Z",
    fill: "#445C77"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M620.006 699.72H606.133V748.651H620.006V699.72Z",
    fill: "#445C77"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M620.006 678.867H606.133V695.499H620.006V678.867Z",
    fill: "#445C77"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M537.123 676.026H534.916V755.298H623.262V752.898H537.123V676.026Z",
    fill: "#8AADC1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M554.442 568.98H540.568V617.911H554.442V568.98Z",
    fill: "#445C77"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M554.442 548.128H540.568V564.76H554.442V548.128Z",
    fill: "#445C77"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M603.289 568.98H557.254V617.911H603.289V568.98Z",
    fill: "#445C77"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M603.289 548.128H557.254V564.76H603.289V548.128Z",
    fill: "#445C77"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M620.004 568.98H606.131V617.911H620.004V568.98Z",
    fill: "#445C77"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M620.004 548.128H606.131V564.76H620.004V548.128Z",
    fill: "#445C77"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M537.121 545.259H534.914V624.53H623.26V622.158H537.121V545.259Z",
    fill: "#8AADC1"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M554.444 438.211H540.57V487.142H554.444V438.211Z",
    fill: "#445C77"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M554.444 417.387H540.57V434.019H554.444V417.387Z",
    fill: "#445C77"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M603.291 438.211H557.256V487.142H603.291V438.211Z",
    fill: "#445C77"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M603.291 417.387H557.256V434.019H603.291V417.387Z",
    fill: "#445C77"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M620.006 438.211H606.133V487.142H620.006V438.211Z",
    fill: "#445C77"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M620.006 417.387H606.133V434.019H620.006V417.387Z",
    fill: "#445C77"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M537.123 414.519H534.916V493.79H623.262V491.39H537.123V414.519Z",
    fill: "#8AADC1"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 252.914H648.664V375.71H834.982V252.914Z",
    fill: "#F2786B"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M652.746 252.914H648.664V375.71H652.746V252.914Z",
    fill: "#B72E41"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M846.541 244.943H377.643V260.858H846.541V244.943Z",
    fill: "#0F3554"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M769.364 281.986H691.527V375.711H769.364V281.986Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M765.203 287.062H732.711V370.884H765.203V287.062Z",
    fill: "#445C77"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M727.992 287.062H695.5V370.884H727.992V287.062Z",
    fill: "#445C77"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M648.667 263.01L389.201 271.119V260.858H648.667V263.01Z",
    fill: "#8AADC1"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 264.692L648.664 275.78V260.858H834.982V264.692Z",
    fill: "#B72E41"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 356.568H667.861V375.683H674.922V356.568Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 356.568H749.643V375.683H756.704V356.568Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 356.568H831.449V375.683H838.51V356.568Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 356.568H790.545V375.683H797.606V356.568Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 356.568H708.766V375.683H715.827V356.568Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 356.568H667.861V360.402H674.922V356.568Z",
    fill: "#8AADC1"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 356.568H749.643V360.402H756.704V356.568Z",
    fill: "#8AADC1"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 356.568H831.449V360.402H838.51V356.568Z",
    fill: "#8AADC1"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 356.568H790.545V360.402H797.606V356.568Z",
    fill: "#8AADC1"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 356.568H708.766V360.402H715.827V356.568Z",
    fill: "#8AADC1"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M846.539 353.12H648.664V356.568H846.539V353.12Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 307.473H418.518V356.404H432.392V307.473Z",
    fill: "#445C77"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 286.62H418.518V303.252H432.392V286.62Z",
    fill: "#445C77"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 307.473H435.205V356.404H481.24V307.473Z",
    fill: "#445C77"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 286.62H435.205V303.252H481.24V286.62Z",
    fill: "#445C77"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 307.473H484.082V356.404H497.956V307.473Z",
    fill: "#445C77"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 286.62H484.082V303.252H497.956V286.62Z",
    fill: "#445C77"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M415.098 283.779H412.863V363.051H501.209V360.651H415.098V283.779Z",
    fill: "#8AADC1"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M554.442 307.473H540.568V356.404H554.442V307.473Z",
    fill: "#445C77"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M554.442 286.62H540.568V303.252H554.442V286.62Z",
    fill: "#445C77"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M603.289 307.473H557.254V356.404H603.289V307.473Z",
    fill: "#445C77"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M603.289 286.62H557.254V303.252H603.289V286.62Z",
    fill: "#445C77"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M620.004 307.473H606.131V356.404H620.004V307.473Z",
    fill: "#445C77"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M620.004 286.62H606.131V303.252H620.004V286.62Z",
    fill: "#445C77"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M537.121 283.779H534.914V363.051H623.26V360.651H537.121V283.779Z",
    fill: "#8AADC1"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 122.146H648.664V244.943H834.982V122.146Z",
    fill: "#F2786B"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M652.746 122.146H648.664V244.943H652.746V122.146Z",
    fill: "#B72E41"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M846.541 114.203H377.643V130.118H846.541V114.203Z",
    fill: "#0F3554"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M769.364 151.219H691.527V244.943H769.364V151.219Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M765.203 156.321H732.711V240.144H765.203V156.321Z",
    fill: "#445C77"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M727.992 156.321H695.5V240.144H727.992V156.321Z",
    fill: "#445C77"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M648.667 132.242L389.201 140.379V130.118H648.667V132.242Z",
    fill: "#8AADC1"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M834.982 133.952L648.664 145.04V130.118H834.982V133.952Z",
    fill: "#B72E41"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 225.828H667.861V244.943H674.922V225.828Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 225.828H749.643V244.943H756.704V225.828Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 225.828H831.449V244.943H838.51V225.828Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 225.828H790.545V244.943H797.606V225.828Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 225.828H708.766V244.943H715.827V225.828Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M674.922 225.828H667.861V229.662H674.922V225.828Z",
    fill: "#8AADC1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M756.704 225.828H749.643V229.662H756.704V225.828Z",
    fill: "#8AADC1"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M838.51 225.828H831.449V229.662H838.51V225.828Z",
    fill: "#8AADC1"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M797.606 225.828H790.545V229.662H797.606V225.828Z",
    fill: "#8AADC1"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M715.827 225.828H708.766V229.662H715.827V225.828Z",
    fill: "#8AADC1"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M846.539 222.354H648.664V225.801H846.539V222.354Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 176.733H418.518V225.664H432.392V176.733Z",
    fill: "#445C77"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M432.392 155.881H418.518V172.513H432.392V155.881Z",
    fill: "#445C77"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 176.733H435.205V225.664H481.24V176.733Z",
    fill: "#445C77"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M481.24 155.881H435.205V172.513H481.24V155.881Z",
    fill: "#445C77"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 176.733H484.082V225.664H497.956V176.733Z",
    fill: "#445C77"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M497.956 155.881H484.082V172.513H497.956V155.881Z",
    fill: "#445C77"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M415.098 153.012H412.863V232.283H501.209V229.911H415.098V153.012Z",
    fill: "#8AADC1"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M554.442 176.732H540.568V225.663H554.442V176.732Z",
    fill: "#445C77"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M554.442 155.88H540.568V172.512H554.442V155.88Z",
    fill: "#445C77"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M603.289 176.732H557.254V225.663H603.289V176.732Z",
    fill: "#445C77"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M603.289 155.88H557.254V172.512H603.289V155.88Z",
    fill: "#445C77"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M620.004 176.732H606.131V225.663H620.004V176.732Z",
    fill: "#445C77"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M620.004 155.88H606.131V172.512H620.004V155.88Z",
    fill: "#445C77"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M537.121 153.012H534.914V232.283H623.26V229.911H537.121V153.012Z",
    fill: "#8AADC1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M734.778 829.687H718.395V878.618H734.778V829.687Z",
    fill: "#445C77"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M734.778 808.834H718.395V825.466H734.778V808.834Z",
    fill: "#445C77"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M792.507 829.687H738.115V878.618H792.507V829.687Z",
    fill: "#445C77"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M792.507 808.834H738.115V825.466H792.507V808.834Z",
    fill: "#445C77"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M812.23 829.687H795.846V878.618H812.23V829.687Z",
    fill: "#445C77"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M812.23 808.834H795.846V825.466H812.23V808.834Z",
    fill: "#445C77"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M714.341 805.993H711.721V885.265H816.065V882.865H714.341V805.993Z",
    fill: "#8AADC1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M585.997 805.993H584.562V894.615H585.997V805.993Z",
    fill: "#8AADC1"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M639.341 805.993H637.906V894.615H639.341V805.993Z",
    fill: "#8AADC1"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M643.564 799.291H580.346V805.993H643.564V799.291Z",
    fill: "#F2786B"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M846.539 637.19H377.641V653.105H846.539V637.19Z",
    fill: "#0F3554"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016 932.522H391.851C391.111 929.774 389.202 927.618 386.997 926.631C384.644 925.578 382.028 925.742 379.609 926.532C380.053 926.384 380.646 925.463 380.958 925.084C381.699 924.146 382.307 923.176 382.472 921.892C382.669 920.461 382.291 919.013 381.518 917.877C380.218 915.985 377.947 915.31 375.923 915.557C375.825 915.574 375.726 915.59 375.627 915.607C375.232 915.672 374.837 915.788 374.459 915.952C372.83 916.676 371.398 917.943 370.164 919.342C369.934 919.605 369.704 919.868 369.49 920.164C369.49 920.164 372.929 916.89 373.735 914.422C376.713 907.363 370.411 897.129 362.562 900.025C359.403 901.538 356.836 904.665 355.142 908.317C361.411 897.556 351.012 891.024 347.309 900.699C349.596 892.719 346.19 884.377 339.296 889.066C339.197 889.115 339.099 889.165 339 889.198V932.522H339.016Z",
    fill: "#479DA3"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016 932.522H370.147C369.703 930.893 368.584 929.626 367.284 929.05C365.902 928.425 364.355 928.524 362.924 928.984C363.648 927.372 362.66 925.183 361.262 924.542C359.863 923.916 358.316 924.443 356.967 925.216C358.119 924.591 358.991 923.291 359.468 921.827C361.229 917.664 357.51 911.642 352.887 913.336C351.027 914.225 349.513 916.068 348.51 918.223C352.212 911.888 346.074 908.038 343.902 913.748C346.025 907.512 341.928 903.859 339.016 905.257V932.522Z",
    fill: "#7BBFBA"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M371.3 898.445C370.461 899.301 369.26 899.185 369.26 899.185C369.26 899.185 369.408 897.672 370.247 896.816C371.086 895.96 372.287 896.075 372.287 896.075C372.287 896.075 372.123 897.589 371.3 898.445Z",
    fill: "#479DA3"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M347.295 908.432C346.669 909.716 345.337 910.111 345.337 910.111C345.337 910.111 345.007 908.416 345.633 907.132C346.258 905.849 347.591 905.454 347.591 905.454C347.591 905.454 347.903 907.149 347.295 908.432Z",
    fill: "#7BBFBA"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M368.766 895.039C369.128 896.849 368.289 898.676 368.289 898.676C368.289 898.676 366.874 897.557 366.528 895.747C366.166 893.937 367.005 892.11 367.005 892.11C367.005 892.11 368.404 893.229 368.766 895.039Z",
    fill: "#479DA3"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M824.416 932.373L823.083 913.088L833.746 900.731L833.087 900.205L826.802 905.602L825.88 900.205L824.893 900.468L825.058 907.181L822.507 909.666L821.52 889.97L826.753 883.504L826.177 883.01L820.763 887.337L820.418 877.037H819.003L818.065 889.707L816.699 902.278L809.657 894.643L808.998 895.087L811.565 899.119L807.09 899.069V899.81L811.977 900.55L816.781 908.086L815.695 932.373H824.416Z",
    fill: "#994F61"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M778.871 862.64C778.789 860.238 778.97 857.769 779.974 855.581C780.977 853.393 782.952 851.55 785.337 851.204C786.72 851.007 788.25 851.385 789.106 852.488C786.423 849.147 783.972 845.495 782.919 841.348C781.866 837.202 782.392 832.463 785.14 829.188C787.789 826.046 792.232 824.68 796.312 825.272C800.393 825.865 804.079 828.251 806.761 831.377C806.465 824.943 804.984 818.444 806.169 812.109C807.353 805.774 812.388 799.423 818.822 799.719C823.182 799.916 826.852 803.043 829.649 806.399C835.424 813.392 838.978 822.179 839.702 831.212C841.381 828.909 843.075 826.572 845.313 824.812C847.551 823.051 850.43 821.916 853.244 822.376C857.868 823.133 860.813 827.839 861.932 832.381C863.133 837.235 862.952 842.418 861.438 847.173C858.921 855.038 853.014 861.291 847.288 867.247C849.92 866.079 853.244 867.658 854.511 870.242C856.239 873.747 854.593 877.794 852.191 880.591C850.167 882.944 847.485 884.639 844.721 886.021C829.205 893.804 810.315 892.685 794.667 885.906C788.859 883.389 784.795 879.226 781.701 873.664C781.685 873.648 781.685 873.615 781.668 873.598C779.792 870.308 779.003 866.457 778.871 862.64Z",
    fill: "#479DA3"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M828.712 895.334C829.436 894.495 831.575 894.166 831.542 895.696C832.167 890.957 838.37 892.751 835.474 897.276C840.23 892.339 844.458 898.658 838.288 901.471C843.52 901.57 840.592 909.04 836.001 905.782C837.86 906.901 836.676 909.353 834.668 909.024C829.353 908.168 823.907 899.678 828.712 895.334Z",
    fill: "#479DA3"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M838.006 881.348C838.434 880.081 838.731 878.732 838.55 877.416C838.369 876.099 837.612 874.8 836.394 874.24C835.686 873.911 834.814 873.878 834.189 874.322C836.147 872.973 838.039 871.426 839.257 869.386C840.475 867.346 840.952 864.746 840.014 862.558C839.109 860.451 836.97 859.02 834.699 858.691C832.428 858.362 830.092 859.036 828.167 860.27C829.352 856.897 831.178 853.672 831.556 850.118C831.935 846.564 830.273 842.385 826.801 841.513C824.448 840.92 821.997 841.99 819.973 843.339C815.793 846.136 812.486 850.233 810.66 854.923C810.133 853.426 809.607 851.912 808.702 850.628C807.797 849.328 806.447 848.275 804.868 848.061C802.284 847.732 799.981 849.756 798.648 851.994C797.233 854.38 796.493 857.161 796.542 859.941C796.624 864.532 798.763 868.794 800.853 872.874C799.635 871.838 797.628 872.134 796.542 873.319C795.061 874.915 795.291 877.317 796.131 879.193C796.838 880.772 797.99 882.089 799.24 883.273C806.25 889.888 816.468 892.307 825.88 891.204C829.368 890.793 832.198 889.23 834.732 886.762C834.748 886.745 834.749 886.745 834.765 886.729C836.295 885.264 837.332 883.356 838.006 881.348Z",
    fill: "#7BBFBA"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M855.597 865.207C854.708 866.819 855.235 868.827 855.235 868.827C855.235 868.827 857.209 868.201 858.098 866.589C858.987 864.976 858.46 862.969 858.46 862.969C858.46 862.969 856.485 863.594 855.597 865.207Z",
    fill: "#479DA3"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M860.929 868.613C858.395 868.465 856.223 870.308 856.223 870.308C856.223 870.308 858.164 872.397 860.698 872.546C863.232 872.694 865.404 870.851 865.404 870.851C865.404 870.851 863.462 868.761 860.929 868.613Z",
    fill: "#479DA3"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M805.395 901.308C806.3 900.929 806.744 899.909 806.744 899.909C806.744 899.909 805.707 899.514 804.802 899.893C803.898 900.271 803.453 901.291 803.453 901.291C803.453 901.291 804.49 901.686 805.395 901.308Z",
    fill: "#479DA3"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M804.291 898.099C805.295 899.004 806.826 898.955 806.826 898.955C806.826 898.955 806.71 897.441 805.69 896.536C804.687 895.631 803.156 895.68 803.156 895.68C803.156 895.68 803.271 897.21 804.291 898.099Z",
    fill: "#479DA3"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M805.675 845.116C806.958 846.433 809.031 846.515 809.031 846.515C809.031 846.515 809.015 844.442 807.732 843.125C806.448 841.809 804.375 841.727 804.375 841.727C804.375 841.727 804.375 843.784 805.675 845.116Z",
    fill: "#7BBFBA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M836.788 855.581C835.587 856.042 834.979 857.342 834.979 857.342C834.979 857.342 836.295 857.901 837.496 857.44C838.697 856.98 839.306 855.68 839.306 855.68C839.306 855.68 837.99 855.137 836.788 855.581Z",
    fill: "#7BBFBA"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M810.48 840.986C809.608 843.372 810.743 845.972 810.743 845.972C810.743 845.972 813.293 844.721 814.182 842.335C815.071 839.949 813.919 837.35 813.919 837.35C813.919 837.35 811.352 838.617 810.48 840.986Z",
    fill: "#7BBFBA"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M831.805 906.244C832.266 906.31 832.743 906.31 833.171 906.26C833.812 906.178 834.438 905.899 834.849 905.405C835.194 904.994 835.392 904.319 835.194 903.792C834.915 903.019 833.911 903.2 833.45 902.624C833.204 902.311 833.187 901.867 833.253 901.456C833.302 901.061 833.401 900.633 833.302 900.255C833.203 899.86 832.825 899.498 832.43 899.58C832.134 899.646 831.953 899.942 831.755 900.14C831.64 900.271 831.476 900.386 831.295 900.37C830.538 900.353 830.373 899.235 829.583 899.383C828.761 899.531 828.3 900.386 828.07 901.11C827.675 902.377 827.856 903.759 828.728 904.796C829.501 905.734 830.637 906.096 831.805 906.244Z",
    fill: "#7BBFBA"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M434.023 932.372L433.069 918.485L440.736 909.583L440.276 909.205L435.734 913.088L435.076 909.205L434.369 909.402L434.484 914.223L432.641 916.017L431.95 901.833L435.701 897.177L435.29 896.815L431.39 899.941L431.144 892.52H430.124L429.449 901.636L428.462 910.702L423.394 905.206L422.917 905.519L424.759 908.431L421.551 908.382V908.925L425.072 909.452L428.527 914.882L427.738 932.372H434.023Z",
    fill: "#994F61"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M401.23 882.154C401.164 880.427 401.296 878.649 402.02 877.07C402.744 875.507 404.159 874.174 405.886 873.927C406.874 873.779 407.976 874.059 408.601 874.849C406.676 872.446 404.899 869.814 404.142 866.835C403.385 863.841 403.764 860.435 405.755 858.082C407.663 855.811 410.856 854.84 413.801 855.268C416.73 855.696 419.395 857.407 421.32 859.661C421.106 855.021 420.037 850.348 420.893 845.79C421.748 841.233 425.368 836.658 430.008 836.856C433.151 836.987 435.8 839.242 437.808 841.677C441.97 846.712 444.537 853.047 445.047 859.546C446.249 857.884 447.483 856.206 449.095 854.939C450.708 853.672 452.781 852.849 454.805 853.178C458.129 853.721 460.251 857.111 461.057 860.385C461.929 863.874 461.798 867.609 460.695 871.048C458.885 876.708 454.624 881.216 450.51 885.511C452.402 884.672 454.788 885.807 455.71 887.666C456.96 890.2 455.775 893.113 454.031 895.12C452.567 896.815 450.642 898.033 448.651 899.036C437.478 904.647 423.871 903.841 412.6 898.954C408.404 897.144 405.491 894.149 403.27 890.135C403.254 890.118 403.254 890.102 403.237 890.085C401.888 887.666 401.329 884.902 401.23 882.154Z",
    fill: "#479DA3"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M437.117 905.7C437.643 905.092 439.173 904.861 439.157 905.964C439.618 902.558 444.077 903.841 441.987 907.099C445.41 903.545 448.454 908.086 444.011 910.127C447.779 910.209 445.673 915.589 442.365 913.236C443.698 914.043 442.859 915.803 441.411 915.573C437.577 914.931 433.661 908.827 437.117 905.7Z",
    fill: "#479DA3"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M443.814 895.63C444.126 894.725 444.34 893.754 444.209 892.8C444.077 891.846 443.534 890.908 442.662 890.513C442.152 890.283 441.527 890.25 441.066 890.579C442.481 889.608 443.83 888.489 444.719 887.025C445.607 885.56 445.936 883.684 445.262 882.105C444.604 880.591 443.057 879.554 441.428 879.324C439.799 879.077 438.121 879.571 436.722 880.459C437.578 878.024 438.894 875.704 439.174 873.154C439.454 870.587 438.252 867.576 435.751 866.951C434.056 866.523 432.296 867.296 430.831 868.267C427.82 870.274 425.435 873.236 424.135 876.609C423.756 875.54 423.378 874.437 422.72 873.516C422.061 872.578 421.091 871.821 419.955 871.673C418.096 871.426 416.434 872.89 415.48 874.503C414.46 876.231 413.933 878.222 413.966 880.229C414.032 883.536 415.562 886.597 417.076 889.542C416.204 888.785 414.756 889.016 413.966 889.855C412.896 891.007 413.061 892.734 413.67 894.084C414.18 895.219 415.003 896.173 415.908 897.029C420.959 901.801 428.314 903.545 435.093 902.738C437.611 902.442 439.634 901.323 441.461 899.546L441.477 899.53C442.58 898.444 443.32 897.062 443.814 895.63Z",
    fill: "#7BBFBA"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M456.483 883.997C455.842 885.165 456.22 886.597 456.22 886.597C456.22 886.597 457.635 886.153 458.277 884.985C458.919 883.816 458.54 882.385 458.54 882.385C458.54 882.385 457.125 882.829 456.483 883.997Z",
    fill: "#479DA3"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M460.317 886.449C458.491 886.334 456.928 887.666 456.928 887.666C456.928 887.666 458.326 889.164 460.153 889.279C461.979 889.394 463.542 888.061 463.542 888.061C463.542 888.061 462.144 886.564 460.317 886.449Z",
    fill: "#479DA3"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M420.317 909.994C420.975 909.715 421.287 908.991 421.287 908.991C421.287 908.991 420.547 908.711 419.889 908.974C419.231 909.254 418.918 909.978 418.918 909.978C418.918 909.978 419.658 910.274 420.317 909.994Z",
    fill: "#479DA3"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M419.529 907.692C420.253 908.333 421.355 908.301 421.355 908.301C421.355 908.301 421.273 907.215 420.549 906.556C419.825 905.915 418.723 905.948 418.723 905.948C418.723 905.948 418.805 907.05 419.529 907.692Z",
    fill: "#479DA3"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M420.514 869.518C421.435 870.472 422.933 870.521 422.933 870.521C422.933 870.521 422.916 869.024 421.995 868.086C421.073 867.132 419.576 867.082 419.576 867.082C419.576 867.082 419.593 868.58 420.514 869.518Z",
    fill: "#7BBFBA"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M442.94 877.07C442.085 877.399 441.641 878.337 441.641 878.337C441.641 878.337 442.595 878.732 443.451 878.403C444.306 878.074 444.75 877.136 444.75 877.136C444.75 877.136 443.796 876.741 442.94 877.07Z",
    fill: "#7BBFBA"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M423.986 866.556C423.36 868.267 424.167 870.143 424.167 870.143C424.167 870.143 426.01 869.238 426.635 867.527C427.26 865.816 426.454 863.94 426.454 863.94C426.454 863.94 424.611 864.845 423.986 866.556Z",
    fill: "#7BBFBA"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M439.338 913.549C439.684 913.598 440.013 913.598 440.325 913.566C440.786 913.5 441.247 913.302 441.526 912.957C441.773 912.661 441.905 912.183 441.773 911.789C441.576 911.229 440.852 911.361 440.523 910.949C440.342 910.719 440.342 910.406 440.375 910.11C440.408 909.814 440.49 909.518 440.408 909.238C440.342 908.958 440.062 908.695 439.782 908.761C439.568 908.81 439.437 909.024 439.289 909.172C439.206 909.271 439.091 909.353 438.96 909.337C438.417 909.32 438.285 908.514 437.726 908.613C437.133 908.712 436.804 909.337 436.64 909.863C436.36 910.768 436.492 911.772 437.117 912.513C437.693 913.187 438.515 913.434 439.338 913.549Z",
    fill: "#7BBFBA"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M387.426 932.373H380.17L381.536 913.5H386.044L387.426 932.373Z",
    fill: "#0F3554"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M384.975 850.76H382.605V932.373H384.975V850.76Z",
    fill: "#0F3554"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M387.541 850.76H380.055L377.307 837.186H390.289L387.541 850.76Z",
    fill: "#0F3554"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M386.142 848.243H381.437L379.709 839.703H387.887L386.142 848.243Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M387.541 833.729H380.055L377.307 837.185H390.289L387.541 833.729Z",
    fill: "#0F3554"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M388.102 850.76H379.497C379.118 850.76 378.789 850.447 378.789 850.052C378.789 849.674 379.102 849.345 379.497 849.345H388.102C388.481 849.345 388.81 849.657 388.81 850.052C388.81 850.447 388.481 850.76 388.102 850.76Z",
    fill: "#0F3554"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M386.143 914.207H381.454C381.075 914.207 380.746 913.894 380.746 913.5C380.746 913.121 381.059 912.792 381.454 912.792H386.143C386.521 912.792 386.851 913.105 386.851 913.5C386.851 913.894 386.538 914.207 386.143 914.207Z",
    fill: "#0F3554"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M385.846 833.73C385.846 834.849 384.925 835.77 383.806 835.77C382.687 835.77 381.766 834.849 381.766 833.73C381.766 832.611 382.687 831.689 383.806 831.689C384.925 831.689 385.846 832.611 385.846 833.73Z",
    fill: "#0F3554"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M770.184 932.373H762.928L764.294 913.5H768.802L770.184 932.373Z",
    fill: "#0F3554"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M767.733 850.76H765.363V932.373H767.733V850.76Z",
    fill: "#0F3554"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M770.299 850.76H762.812L760.064 837.186H773.047L770.299 850.76Z",
    fill: "#0F3554"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M768.9 848.243H764.194L762.467 839.703H770.644L768.9 848.243Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M770.299 833.729H762.812L760.064 837.185H773.047L770.299 833.729Z",
    fill: "#0F3554"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M770.86 850.76H762.254C761.876 850.76 761.547 850.447 761.547 850.052C761.547 849.674 761.86 849.345 762.254 849.345H770.86C771.238 849.345 771.567 849.657 771.567 850.052C771.567 850.447 771.238 850.76 770.86 850.76Z",
    fill: "#0F3554"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M768.901 914.207H764.211C763.833 914.207 763.504 913.894 763.504 913.5C763.504 913.121 763.816 912.792 764.211 912.792H768.901C769.279 912.792 769.608 913.105 769.608 913.5C769.608 913.894 769.296 914.207 768.901 914.207Z",
    fill: "#0F3554"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M768.604 833.73C768.604 834.849 767.683 835.77 766.564 835.77C765.445 835.77 764.523 834.849 764.523 833.73C764.523 832.611 765.428 831.689 766.564 831.689C767.699 831.689 768.604 832.611 768.604 833.73Z",
    fill: "#0F3554"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M696.248 920.973C703.093 899.237 731.131 895.815 740.378 916.794C751.945 913.618 761.258 917.748 768.86 926.189C772.595 921.467 781.448 919.624 788.029 923.474C793.328 906.642 815.047 903.976 822.221 920.249C833.081 917.271 841.39 922.586 847.857 932.113H773.467H760.469H660.674C671.583 922.866 683.117 917.205 696.248 920.973Z",
    fill: "#479DA3"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M722.574 931.965C722.574 931.965 730.801 924.561 747.519 926.404C752.274 921.895 757.984 919.871 764.894 921.78C771.048 907.81 789.707 910.098 794.265 924.561C803.002 922.06 810.67 925.811 817.926 931.965H722.574Z",
    fill: "#7BBFBA"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M638.033 931.965C642.673 925.153 650.028 925.104 657.795 927.243C662.928 915.61 681.719 916.202 685.52 928.263C699.588 923.425 705.759 931.965 705.759 931.965H638.033Z",
    fill: "#7BBFBA"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M717.079 898.942C717.968 900.653 720.008 901.36 720.008 901.36C720.008 901.36 720.617 899.287 719.745 897.576C718.856 895.865 716.816 895.157 716.816 895.157C716.816 895.157 716.207 897.23 717.079 898.942Z",
    fill: "#479DA3"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M723.151 896.292C721.554 898.398 721.884 901.344 721.884 901.344C721.884 901.344 724.812 900.883 726.408 898.76C728.004 896.654 727.675 893.709 727.675 893.709C727.675 893.709 724.747 894.186 723.151 896.292Z",
    fill: "#479DA3"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M802.114 919.427C802.624 921.287 804.467 922.406 804.467 922.406C804.467 922.406 805.503 920.513 804.993 918.654C804.483 916.795 802.64 915.676 802.64 915.676C802.64 915.676 801.604 917.568 802.114 919.427Z",
    fill: "#7BBFBA"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M808.596 918.111C806.588 919.839 806.309 922.784 806.309 922.784C806.309 922.784 809.27 922.932 811.278 921.204C813.285 919.477 813.565 916.531 813.565 916.531C813.565 916.531 810.603 916.383 808.596 918.111Z",
    fill: "#7BBFBA"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M419.388 924.068C414.451 908.387 394.213 905.919 387.549 921.057C379.206 918.77 372.477 921.748 366.997 927.836C364.299 924.43 357.915 923.097 353.159 925.878C349.342 913.735 333.661 911.809 328.495 923.541C320.662 921.386 314.673 925.22 310 932.097H363.674H373.052H445.073C437.175 925.434 428.865 921.369 419.388 924.068Z",
    fill: "#479DA3"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M400.4 931.999C400.4 931.999 394.461 926.651 382.4 927.984C378.961 924.726 374.847 923.278 369.862 924.644C365.419 914.574 351.959 916.203 348.668 926.651C342.367 924.841 336.838 927.556 331.605 931.999H400.4Z",
    fill: "#7BBFBA"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M461.395 931.998C458.055 927.078 452.74 927.045 447.13 928.592C443.427 920.201 429.869 920.628 427.121 929.333C416.969 925.844 412.51 931.998 412.51 931.998H461.395Z",
    fill: "#7BBFBA"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M404.348 908.173C403.706 909.407 402.242 909.917 402.242 909.917C402.242 909.917 401.797 908.42 402.439 907.186C403.081 905.951 404.545 905.441 404.545 905.441C404.545 905.441 404.989 906.939 404.348 908.173Z",
    fill: "#479DA3"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M399.988 906.264C401.14 907.778 400.893 909.917 400.893 909.917C400.893 909.917 398.77 909.571 397.619 908.057C396.467 906.544 396.714 904.405 396.714 904.405C396.714 904.405 398.82 904.75 399.988 906.264Z",
    fill: "#479DA3"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M343.009 922.949C342.647 924.281 341.314 925.088 341.314 925.088C341.314 925.088 340.574 923.722 340.936 922.373C341.298 921.04 342.63 920.234 342.63 920.234C342.63 920.234 343.371 921.616 343.009 922.949Z",
    fill: "#7BBFBA"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M338.319 922.01C339.767 923.261 339.981 925.384 339.981 925.384C339.981 925.384 337.842 925.499 336.394 924.248C334.946 922.998 334.732 920.875 334.732 920.875C334.732 920.875 336.888 920.76 338.319 922.01Z",
    fill: "#7BBFBA"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M484.114 742.197C482.058 742.23 480.1 742.658 478.339 743.447C474.604 745.109 470.836 743.414 469.306 741.736C465.176 737.162 459.203 734.299 452.555 734.299C445.003 734.299 438.322 738.001 434.209 743.694C431.971 747.166 428.039 746.853 425.965 746.853C420.404 746.853 415.879 751.362 415.879 756.94C415.879 756.956 415.879 756.956 415.879 756.973H484.098V742.197H484.114Z",
    fill: "#D1DFE8"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M467.955 750.325L467.33 749.782C470.654 745.915 476.462 743.645 476.709 743.546L477.005 744.319C476.939 744.336 471.131 746.606 467.955 750.325Z",
    fill: "#AFCBD8"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M435.756 751.773C435.739 751.74 434.011 748.005 427.43 747.248L427.529 746.426C434.604 747.248 436.43 751.263 436.512 751.444L435.756 751.773Z",
    fill: "#AFCBD8"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M340.536 685.709H455.765C455.255 680.115 450.549 675.721 444.823 675.721C442.552 675.721 440.462 676.412 438.702 677.581C436.958 678.617 435.23 678.074 434.671 676.314C432.564 669.666 426.345 664.862 419.006 664.862C417.887 664.862 416.785 664.977 415.732 665.191C411.882 665.799 409.907 664.055 409.348 661.406C406.402 647.996 394.456 637.942 380.158 637.942C366.978 637.942 355.789 646.482 351.807 658.329C350.688 661.472 347.282 661.587 345.308 660.205C343.843 659.168 342.231 658.346 340.52 657.72V685.709H340.536Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M356.381 672.776C353.239 667.099 349.52 663.167 344.32 660.007L344.748 659.3C350.079 662.541 353.88 666.573 357.105 672.364L356.381 672.776Z",
    fill: "#AFCBD8"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M401.664 675.031L400.973 674.587C406.6 665.899 414.876 664.879 415.238 664.846L415.337 665.668C415.238 665.668 407.077 666.672 401.664 675.031Z",
    fill: "#AFCBD8"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M391.264 679.078L390.672 678.503C393.601 675.541 397.5 673.994 401.285 674.257C404.543 674.488 407.373 676.002 409.265 678.535L408.607 679.029C406.863 676.693 404.23 675.278 401.219 675.08C397.665 674.85 394.029 676.298 391.264 679.078Z",
    fill: "#AFCBD8"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M873.224 720.97C871.167 721.003 869.209 721.431 867.449 722.221C863.714 723.883 859.946 722.188 858.415 720.51C854.285 715.935 848.312 713.072 841.665 713.072C834.112 713.072 827.432 716.774 823.318 722.468C821.097 725.939 817.148 725.627 815.075 725.627C809.513 725.627 804.988 730.135 804.988 735.713C804.988 735.73 804.988 735.73 804.988 735.746H873.208V720.97H873.224Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M857.065 729.099L856.439 728.555C859.763 724.689 865.572 722.418 865.818 722.319L866.115 723.093C866.065 723.109 860.257 725.38 857.065 729.099Z",
    fill: "#AFCBD8"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M824.882 730.547C824.865 730.514 823.137 726.779 816.572 726.022L816.671 725.199C823.746 726.022 825.573 730.037 825.655 730.218L824.882 730.547Z",
    fill: "#AFCBD8"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1016 97.6926C46.1382 84.9406 56.8005 74.92 69.8158 74.92C71.1651 74.92 72.4978 75.0352 73.7812 75.2326C79.3757 76.0882 83.917 74.2454 85.908 69.0459C91.7822 53.6612 106.673 42.7191 124.131 42.7191C135.057 42.7191 144.979 47.0137 152.317 54.0067C155.394 56.7875 159.557 56.6887 161.828 52.8878C169.94 36.5488 186.789 25.3105 206.271 25.3105C228.336 25.3105 247.044 39.7244 253.478 59.6505C254.3 62.1844 257.361 65.2614 262.577 63.3033C266.312 61.7566 270.426 60.901 274.72 60.901C285.004 60.901 294.153 65.7879 299.977 73.3733C302.281 75.9566 305.292 76.1376 308.073 73.472C313.75 66.8574 322.158 62.6781 331.553 62.6781C345.671 62.6781 357.584 72.1392 361.286 85.0723C362.372 87.9846 365.235 88.0011 366.962 86.8822C370.138 84.8419 373.923 83.6572 377.97 83.6572C387.02 83.6572 394.671 89.5643 397.353 97.7091H45.1016V97.6926Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8159 88.0997C84.8558 77.5854 75.592 75.8413 75.5098 75.8248L75.6579 75.0186C75.7566 75.035 85.333 76.8285 92.507 87.6554L91.8159 88.0997Z",
    fill: "#D1DFE8"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M244.083 80.5149L243.359 80.1365C247.506 72.1891 253.627 66.4959 261.525 63.2051L261.837 63.962C254.022 67.2364 248.197 72.6498 244.083 80.5149Z",
    fill: "#D1DFE8"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M167.653 72.8305C161.153 60.6215 152.745 54.8625 152.646 54.8131L153.107 54.1221C153.19 54.1879 161.779 60.0456 168.377 72.4356L167.653 72.8305Z",
    fill: "#D1DFE8"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M360.695 92.9369L360.037 92.4433C360.169 92.2788 363.163 88.3791 367.787 85.8945L368.182 86.6185C363.723 89.0044 360.712 92.8876 360.695 92.9369Z",
    fill: "#D1DFE8"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 83.0645C182.594 76.1538 175.337 72.2048 167.653 72.5009C160.545 72.7807 154.243 76.7132 150.804 83.0316L150.08 82.6367C153.667 76.0715 160.216 71.9744 167.62 71.6782C175.617 71.382 183.12 75.4462 187.81 82.6038L187.119 83.0645Z",
    fill: "#D1DFE8"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M308.156 91.292C305.392 87.0633 300.916 84.628 296.26 84.8419C291.916 85.0065 288.082 87.4088 285.976 91.2755L285.252 90.8806C287.49 86.7671 291.587 84.2002 296.227 84.0192C301.163 83.8053 305.918 86.3722 308.847 90.8477L308.156 91.292Z",
    fill: "#D1DFE8"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M299.172 84.825L298.514 84.3479C302.084 79.4774 308.156 73.4058 308.222 73.3564L308.798 73.9324C308.732 73.9817 302.709 80.004 299.172 84.825Z",
    fill: "#D1DFE8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginViewBuilding);
export default __webpack_public_path__ + "static/media/login-view-building.673f0a5b7d03b88ec5ae9577b500f2d7.svg";
export { ForwardRef as ReactComponent };